module.exports = __webpack_public_path__ + "f03e37f938e40b8d503187a950768073.svg";